import React from 'react';
import { connect } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { currencyFormat, formatCurrencyToNumber } from '../../helper/publicacionHelper';
import {
    putAdministracionTiposPublicacion,
    deleteAdministracionTiposPublicacion,
    postTiposPublicacionAsociarGrupoPlanes
} from '../../api/axios';
import {
    setTiposPublicacion,
    fetchTiposPublicacionAdmById,
    setTiposGrupoPlanes,
    updateListTiposPublicaciones,
    fetchTiposGrupoPlanesByTipoId
} from '../../actions/tiposPublicacionActions';
import {
    setId,
    setPlanes,
    setPlanesDesdeBusqueda,
    setDataGrupoCopy,
    setDataGrupo
} from '../../actions/planesActions';
import ModalItem from '../General/Modal';
import { editando } from '../../actions/generalActios';
import { toast } from 'react-toastify';
import GoBackArrow from '../General/GoBackArrow';
import { resolveTipoPublicacionId, listaIdsGrupoPlanesParaAsociar } from '../../helper/tipoPublicacionHelper';

/*
 * Promoción en tipos de publicación (checkbox + montos). Dejar en false para ocultar.
 * Para volver a mostrar: poner en true.
 */
const PROMOCION_TIPOS_PUBLICACION = true;

function TipoPublicacionesEditWrapper(props) {
    const navigate = useNavigate();
    const location = useLocation();
    return <TipoPublicacionesEdit {...props} navigate={navigate} location={location} />;
}


class TipoPublicacionesEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            comision: "",
            descripcion: "",
            cambioInputChange: false,
            comisionPredeterminada: "",
            cantidadCuotas: "",
            montoMinimoPromocion: "",
            montoMaximoPromocion: ""
        };
        this.descripcionInputRef = React.createRef();
    };

    componentDidMount() {
        if (!this.props.esEdicion) {
            this.props.fetchTiposPublicacionAdmById({
                idTipoPublicacion: this.props.setTipoPublicacion.id,
                cantidadPagina: 10,
                numeroPagina: 1,
                Estado: null,
                descripcion: ""
            });

            if (this.descripcionInputRef.current) {
                this.descripcionInputRef.current.focus();
            }


        }
    }

    getIdsGrupoPlanes = () => {
        const ids = listaIdsGrupoPlanesParaAsociar(
            this.props.tiposGruposPlanes,
            this.props.tipoPublicacion?.grupoPlanes
        );
        return ids.length > 0 ? ids : null;
    }

    onSubmit = async (event) => {
        event.preventDefault();

        const tp = this.props.tipoPublicacion || {};
        const st = this.props.setTipoPublicacion || {};
        const descripcionEfectiva = st.descripcion !== undefined ? st.descripcion : tp.descripcion;
        const comisionEfectiva = st.comision !== undefined ? st.comision : tp.comision;
        const cuotasEfectivas = st.cantidadCuotas !== undefined ? st.cantidadCuotas : tp.cantidadCuotas;

        if (String(descripcionEfectiva ?? "").trim() === "") {
            toast.error("Debe agregar una descripción");
            return;
        }
        if (comisionEfectiva === "" || comisionEfectiva === undefined || comisionEfectiva === null) {
            toast.error("Debe agregar una comisión");
            return;
        }
        if (cuotasEfectivas === "" || cuotasEfectivas === undefined || cuotasEfectivas === null) {
            toast.error("Debe agregar un número de cuotas válido");
            return;
        }

        const idPublicacion = resolveTipoPublicacionId(
            this.props.tipoPublicacion,
            this.props.setTipoPublicacion
        );
        if (idPublicacion == null || Number.isNaN(idPublicacion)) {
            toast.error("No se pudo identificar el tipo de publicación");
            return;
        }

        let montoMinimoNumero;
        let montoMaximoNumero;
        let aceptaPromocion;
        if (PROMOCION_TIPOS_PUBLICACION) {
            montoMinimoNumero = this.props.setTipoPublicacion.montoMinimoPromocion != undefined && this.props.setTipoPublicacion.montoMinimoPromocion !== ""
                ? formatCurrencyToNumber(this.props.setTipoPublicacion.montoMinimoPromocion)
                : (this.props.setTipoPublicacion.montoMinimo != undefined && this.props.setTipoPublicacion.montoMinimo !== ""
                    ? formatCurrencyToNumber(this.props.setTipoPublicacion.montoMinimo)
                    : this.props.tipoPublicacion.montoMinimo);

            montoMaximoNumero = this.props.setTipoPublicacion.montoMaximoPromocion != undefined && this.props.setTipoPublicacion.montoMaximoPromocion !== ""
                ? formatCurrencyToNumber(this.props.setTipoPublicacion.montoMaximoPromocion)
                : (this.props.setTipoPublicacion.montoMaximo != undefined && this.props.setTipoPublicacion.montoMaximo !== ""
                    ? formatCurrencyToNumber(this.props.setTipoPublicacion.montoMaximo)
                    : this.props.tipoPublicacion.montoMaximo);

            aceptaPromocion = this.props.setTipoPublicacion.aceptaPromocion !== undefined
                ? this.props.setTipoPublicacion.aceptaPromocion
                : (this.props.tipoPublicacion?.aceptaPromocion === true || montoMinimoNumero != null || montoMaximoNumero != null);
        } else {
            montoMinimoNumero = null;
            montoMaximoNumero = null;
            aceptaPromocion = false;
        }

        let data = {
            idTipoPublicacion: idPublicacion,
            descripcion: this.props.setTipoPublicacion.descripcion == undefined ? this.props.tipoPublicacion.descripcion : this.props.setTipoPublicacion.descripcion,
            comision: this.props.setTipoPublicacion.comision == undefined ? this.props.tipoPublicacion.comision : parseFloat(this.props.setTipoPublicacion.comision),
            cantidadCuotas: this.props.setTipoPublicacion.cantidadCuotas == undefined ? this.props.tipoPublicacion.cantidadCuotas : parseInt(this.props.setTipoPublicacion.cantidadCuotas),
            aceptaPromocion,
            montoMinimoPromocion: montoMinimoNumero,
            montoMaximoPromocion: montoMaximoNumero
        }

        let updateTipo = putAdministracionTiposPublicacion(data);

        updateTipo.then(async res => {
            await this.asociarGrupoPlanes(idPublicacion);
            this.props.updateListTiposPublicaciones(this.props.tiposPublicaciones, data);
            toast.success("Tipo publicacion guardada");
            this.goToTipoPublicaciones();
        }).catch(err => {
            toast.error("No pudo editarse");
        });
    }

    asociarGrupoPlanes = (id) => {
        const arrayIdsElement = listaIdsGrupoPlanesParaAsociar(
            this.props.tiposGruposPlanes,
            this.props.tipoPublicacion?.grupoPlanes
        );

        let data = {
            idTipoPublicacion: id,
            listaIdsGrupoPlanes: arrayIdsElement
        }

        return postTiposPublicacionAsociarGrupoPlanes(data)
            .then(res => {
            })
            .catch(err => {
                const apiError = err?.response?.data;

                if (apiError?.errors && apiError.errors.length > 0) {
                    apiError.errors.forEach(e => {
                        toast.error(e.message);
                    });
                } else {
                    toast.error("Ocurrió un error inesperado al asociar los grupos de planes");
                }

                throw err;
            });
    }

    onDelete = () => {
        const idTp = resolveTipoPublicacionId(this.props.tipoPublicacion, this.props.setTipoPublicacion);
        const req = deleteAdministracionTiposPublicacion(idTp ?? this.props.tipoPublicacion.codigo);
        req.then(res => {
            toast.success("Tipo de publicación borrado");
            this.goToTipoPublicaciones();
        }).catch(err => {
            toast.error("No se pudo realizar esta tarea");
        });
    }

    goToBusquedaPlanes = () => {
        const reduxList = this.props.tiposGruposPlanes;
        if (!reduxList || reduxList.length === 0) {
            this.props.setTiposGrupoPlanes(this.props.tipoPublicacion.grupoPlanes || []);
        }

        this.props.editando(true);
        this.props.navigate("/Tipo/Publicaciones/GrupoPlanes/Busqueda");
    }

    goToPlan = (idGrupoPlan) => {
        this.props.setPlanesDesdeBusqueda([]);
        this.props.setDataGrupoCopy({})
        this.props.setPlanes([]);
        this.props.setId(idGrupoPlan);
        this.props.navigate(`/Planes/Editar/${idGrupoPlan}`, { state: { from: this.props.location.pathname } });
    }

    goToTipoPublicaciones = () => {
        this.props.navigate("/Tipo/Publicaciones");
    }

    setData_tiposGruposPlanes = () => {
        if (JSON.stringify(this.props.tiposGruposPlanes) == "[]") {
            this.props.setTiposGrupoPlanes(this.props.tipoPublicacion.grupoPlanes);
        }
    }

    borrarFila = (idGrupoPlan) => {
        this.props.editando(true);

        let currentList = [];
        if (this.props.tiposGruposPlanes && this.props.tiposGruposPlanes.length > 0) {
            currentList = [...this.props.tiposGruposPlanes];
        } else {
            currentList = [...(this.props.tipoPublicacion.grupoPlanes || [])];
        }

        const index = currentList.findIndex(x => x.idGrupoPlan == idGrupoPlan);
        if (index !== -1) {
            currentList.splice(index, 1);
            this.props.setTiposGrupoPlanes(currentList);
        } else {
            this.props.setTiposGrupoPlanes(currentList);
        }
    }


    tablaGrupos = () => {
        let dataSource = [];
        const reduxData = this.props.tiposGruposPlanes;
        const savedData = this.props.tipoPublicacion.grupoPlanes;

        if (reduxData != null) {
            dataSource = reduxData;
        } else {
            dataSource = savedData || [];
        }

        if (!dataSource || dataSource.length === 0) return null;

        return (
            <div className="admin-list-stack">
                {dataSource.map((item, index) => (
                    <div
                        key={item.idGrupoPlan || index}
                        className="admin-list-card p-3 admin-list-card--vigente"
                        role="button"
                        tabIndex={0}
                        onClick={() => this.goToPlan(item.idGrupoPlan)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                this.goToPlan(item.idGrupoPlan);
                            }
                        }}
                    >
                        <div className="row g-2 align-items-center justify-content-between">
                            <div className="col-auto">
                                <span className="admin-id-badge">{item.idGrupoPlan}</span>
                            </div>
                            <div className="col text-break">
                                <div className="admin-list-card__title fw-semibold small mb-0">{item.descripcion}</div>
                            </div>
                            <div className="col-auto">
                                <span className="admin-metric-pill">
                                    {item.comision}
                                    <i className="fas fa-percent" aria-hidden="true" />
                                </span>
                            </div>
                            <div className="col-auto" onClick={(e) => e.stopPropagation()}>
                                <button
                                    type="button"
                                    className="btn btn-link btn-sm text-danger p-0"
                                    onClick={() => {
                                        if (dataSource.length <= 1) {
                                            toast.error("Mantenga al menos un grupo de planes y elimine los que no utilice.");
                                            return;
                                        }
                                        this.borrarFila(item.idGrupoPlan);
                                    }}
                                    aria-label="Quitar grupo"
                                >
                                    <i className="fas fa-trash-alt" />
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        );
    }



    tablaGrupos2 = () => {
        let jsonData = JSON.stringify(this.props.tiposGruposPlanes);

        if ((jsonData != "[]" && jsonData != undefined) || (this.props.tipoPublicacion.grupoPlanes != undefined)) {
            var rows = [];
            let htmlData;

            this.props.tipoPublicacion.grupoPlanes.map((item, index) => {

                htmlData =
                    <div className="list-group" key={index}>
                        <a onClick={() => this.goToPlan(item.idGrupoPlan)}>
                            <div className="list-group-item hover-background-color">
                                <div className="row justify-content-between align-items-center">

                                    <div className="col-2 col-md-1">
                                        <h6 className="box-title font-weight-bold text-center">{item.idGrupoPlan}</h6>
                                    </div>

                                    <div className="col-6 col-md-6 text-break">
                                        <small className="font-14 applyFont">{item.descripcion}</small>
                                    </div>
                                    <div className="col-2 col-md-1 d-flex justify-content-end align-items-center">
                                        <small className="font-14 applyFont">{item.comision}</small>
                                        <i className="fas fa-percent mx-1" />
                                    </div>
                                    <div className="col-2 col-md-1 d-flex justify-content-end align-items-center">
                                        <i className="fas fa-trash-alt"
                                            onClick={(e) => (e.stopPropagation(), this.borrarFila(item.idGrupoPlan))} />
                                    </div>

                                </div>
                            </div>
                        </a>
                    </div>
                rows.push(htmlData);

            });
            return rows;
        }

    }


    inputChange = (e) => {

        var numbersOnly = /^[0-9.]+$/;
        let valor = e.target.value;

        if (e.target.name === "comision") {

            let esNumero = valor.match(numbersOnly);

            if (esNumero == null) {
                this.setState({ cambioInputChange: true, comisionPredeterminada: "" });
                return;
            }

            if (e.target.value >= 100) {
                this.setState({ cambioInputChange: true, comisionPredeterminada: 100 });
            } else {
                this.setState({ cambioInputChange: true, comisionPredeterminada: valor });
                let estado = { ...this.props.setTipoPublicacion, [e.target.name]: valor };
                this.props.setTiposPublicacion(estado);
            }
        } else if (e.target.name === "cantidadCuotas") {
            let numbersOnlyInt = /^[0-9]+$/;
            let esNumero = valor.match(numbersOnlyInt);
            if (valor !== "" && esNumero == null) {
                return;
            }
            let estado = { ...this.props.setTipoPublicacion, [e.target.name]: valor }
            this.props.setTiposPublicacion(estado);
        } else if (PROMOCION_TIPOS_PUBLICACION && e.target.name === "aceptaPromocion") {
            const checked = e.target.checked;
            const estado = { ...this.props.setTipoPublicacion, aceptaPromocion: checked };
            this.props.setTiposPublicacion(estado);
        } else if (PROMOCION_TIPOS_PUBLICACION && (e.target.name === "montoMinimoPromocion" || e.target.name === "montoMaximoPromocion")) {
            let formattedValue = currencyFormat(valor);
            let estado = { ...this.props.setTipoPublicacion, aceptaPromocion: true, [e.target.name]: formattedValue }
            this.props.setTiposPublicacion(estado);
        } else {
            let estado = { ...this.props.setTipoPublicacion, [e.target.name]: valor }
            this.props.setTiposPublicacion(estado);
        }
    }


    render() {
        let descripcion, comision, cantidadCuotas, montoMinimoPromocion, montoMaximoPromocion
        const tieneMontoSet = PROMOCION_TIPOS_PUBLICACION && (
            this.props.setTipoPublicacion?.montoMinimoPromocion !== undefined && this.props.setTipoPublicacion?.montoMinimoPromocion !== ""
            || this.props.setTipoPublicacion?.montoMaximoPromocion !== undefined && this.props.setTipoPublicacion?.montoMaximoPromocion !== "");
        const tieneMontoBase = PROMOCION_TIPOS_PUBLICACION && (
            this.props.tipoPublicacion?.montoMinimo !== null && this.props.tipoPublicacion?.montoMinimo !== undefined
            || this.props.tipoPublicacion?.montoMaximo !== null && this.props.tipoPublicacion?.montoMaximo !== undefined);
        const aceptaPromocion = PROMOCION_TIPOS_PUBLICACION
            ? (this.props.setTipoPublicacion?.aceptaPromocion !== undefined
                ? this.props.setTipoPublicacion.aceptaPromocion
                : (this.props.tipoPublicacion?.aceptaPromocion === true || tieneMontoSet || tieneMontoBase))
            : false;
        if (this.state.cambioInputChange) {
            comision = this.state.comisionPredeterminada;
            if (PROMOCION_TIPOS_PUBLICACION) {
                montoMinimoPromocion = this.props.setTipoPublicacion.montoMinimoPromocion != undefined
                    ? this.props.setTipoPublicacion.montoMinimoPromocion
                    : (this.props.setTipoPublicacion.montoMinimo != undefined
                        ? this.props.setTipoPublicacion.montoMinimo
                        : this.props.tipoPublicacion.montoMinimo);
                montoMaximoPromocion = this.props.setTipoPublicacion.montoMaximoPromocion != undefined
                    ? this.props.setTipoPublicacion.montoMaximoPromocion
                    : (this.props.setTipoPublicacion.montoMaximo != undefined
                        ? this.props.setTipoPublicacion.montoMaximo
                        : this.props.tipoPublicacion.montoMaximo);
            }
        } else {
            descripcion = this.props.setTipoPublicacion.descripcion != undefined ? this.props.setTipoPublicacion.descripcion : this.props.tipoPublicacion.descripcion;
            comision = this.props.setTipoPublicacion.comision != undefined ? this.props.setTipoPublicacion.comision : this.props.tipoPublicacion.comision;
            cantidadCuotas = this.props.setTipoPublicacion.cantidadCuotas != undefined ? this.props.setTipoPublicacion.cantidadCuotas : this.props.tipoPublicacion.cantidadCuotas;
            if (PROMOCION_TIPOS_PUBLICACION) {
                montoMinimoPromocion = this.props.setTipoPublicacion.montoMinimoPromocion != undefined
                    ? this.props.setTipoPublicacion.montoMinimoPromocion
                    : (this.props.setTipoPublicacion.montoMinimo != undefined
                        ? this.props.setTipoPublicacion.montoMinimo
                        : this.props.tipoPublicacion.montoMinimo);
                montoMaximoPromocion = this.props.setTipoPublicacion.montoMaximoPromocion != undefined
                    ? this.props.setTipoPublicacion.montoMaximoPromocion
                    : (this.props.setTipoPublicacion.montoMaximo != undefined
                        ? this.props.setTipoPublicacion.montoMaximo
                        : this.props.tipoPublicacion.montoMaximo);
            }
        }

        return (
            <div className="container py-2">
                <div className="card admin-grupo-busqueda-shell border-0 bg-white">
                    <div className="admin-grupo-busqueda-header">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
                            <div className="d-flex align-items-center gap-2">
                                <GoBackArrow />
                                <div>
                                    <h4 className="mb-0 text-body fw-semibold">Editar tipo de publicación</h4>
                                    <p className="small text-body-secondary mb-0 mt-1 d-none d-md-block">Datos del tipo y grupos de planes vinculados.</p>
                                </div>
                            </div>
                            <button
                                type="button"
                                onClick={this.goToBusquedaPlanes}
                                className="btn btn-sm background-rojo-megatone text-white"
                            >
                                <i className="fa fa-plus-circle me-1" /> Agregar grupo de planes
                            </button>
                        </div>
                    </div>

                    <div className="px-4 pb-4 pt-2">
                    <form className="form-horizontal form-material" onSubmit={this.onSubmit}>
                        <div className="form-group">
                            <div className="row g-3 justify-content-evenly">

                                <div className="col-12 col-md-4">

                                    <label className="label-oscura">Descripción</label>
                                    <input
                                        name="descripcion"
                                        value={descripcion}
                                        onChange={this.inputChange}
                                        type="text"
                                        id="firstName"
                                        className="form-control"
                                        ref={this.descripcionInputRef}
                                    />
                                </div>

                                <div className="col-12 col-md-4">

                                    <small className="font-14 applyFont">
                                        <i className="fas fa-percent mx-1" />
                                    </small>

                                    <label className="label-oscura">Comisión</label>
                                    <input
                                        name="comision"
                                        value={comision}
                                        onChange={this.inputChange}
                                        type="text"
                                        className="form-control"
                                        maxLength="5"
                                    />
                                </div>

                                <div className="col-12 col-md-4">
                                    <label className="label-oscura">N° Cuotas</label>
                                    <input
                                        name="cantidadCuotas"
                                        value={cantidadCuotas}
                                        onChange={this.inputChange}
                                        type="text"
                                        className="form-control"
                                        maxLength="5"
                                    />
                                </div>

                            </div>

                            {PROMOCION_TIPOS_PUBLICACION && (
                            <div className="row g-3 justify-content-evenly mt-2">
                                <div className="col-12 mb-2">
                                    <div className="form-check form-switch d-flex align-items-center gap-2">
                                        <label className="form-check-label label-oscura mb-0" htmlFor="habilitarPromocionEdit">
                                            Habilitar promoción
                                        </label>
                                        <input
                                            className="form-check-input m-0"
                                            type="checkbox"
                                            id="habilitarPromocionEdit"
                                            name="aceptaPromocion"
                                            checked={aceptaPromocion}
                                            onChange={this.inputChange}
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-md-4">
                                    <label className="label-oscura">Monto mínimo promoción</label>
                                    <input
                                        name="montoMinimoPromocion"
                                        value={montoMinimoPromocion ?? ''}
                                        onChange={this.inputChange}
                                        type="text"
                                        className="form-control"
                                        maxLength="12"
                                        disabled={!aceptaPromocion}
                                    />
                                </div>

                                <div className="col-12 col-md-4">
                                    <label className="label-oscura">Monto máximo promoción</label>
                                    <input
                                        name="montoMaximoPromocion"
                                        value={montoMaximoPromocion ?? ''}
                                        onChange={this.inputChange}
                                        type="text"
                                        className="form-control"
                                        maxLength="12"
                                        disabled={!aceptaPromocion}
                                    />
                                </div>

                            </div>
                            )}
                        </div>

                        <label className="label-oscura d-block mt-3 mb-2">Grupos de planes</label>
                        {this.tablaGrupos()}

                        <div className="d-flex flex-wrap justify-content-center align-items-center gap-2 mt-4 pt-3 border-top">

                            <button
                                type="submit"
                                className="btn btn-sm background-rojo-megatone text-white px-4"
                            >
                                Guardar
                            </button>

                            <ModalItem
                                text="¿Desea eliminar el tipo de publicación?"
                                onDelete={this.onDelete}
                                show={this.state.showModal}
                                btnText="Eliminar"
                                btnStyle="btn btn-sm btn-grey"
                            />

                            <button
                                type="button"
                                onClick={this.goToTipoPublicaciones}
                                className="btn btn-sm btn-light"
                            >
                                Cancelar
                            </button>

                        </div>
                    </form>
                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => ({
    esEdicion: state.general.editando,
    tipoPublicacion: state.tiposPublicacion.tiposPublicacion,
    tiposGruposPlanes: state.tiposPublicacion.tiposGruposPlanes,
    setTipoPublicacion: state.tiposPublicacion.setTiposPublicacion,
    tiposPublicaciones: state.tiposPublicacion.tiposPublicaciones,
});

export default connect(mapStateToProps, {
    fetchTiposPublicacionAdmById,
    setTiposPublicacion,
    setTiposGrupoPlanes,
    editando,
    setId,
    setPlanes,
    setDataGrupo,
    setDataGrupoCopy,
    setPlanesDesdeBusqueda,
    updateListTiposPublicaciones,
    fetchTiposGrupoPlanesByTipoId
})(TipoPublicacionesEditWrapper);
